import { TABLE_FLUID_CLASS, TABLE_SCROLL_CLASS } from './styles';

const isFluidWidth = (width: string) => !width || width.endsWith('%');

/**
 * 최상위 표를 가로 스크롤 상자로 감싸고 폭이 % 이거나 없는 표를 표시.
 * width 속성은 CSS 기본 폭에 덮이므로 인라인 style 로 옮김.
 * 표 자체를 스크롤 상자로 쓰면 좁은 화면에서 표가 먼저 글자 단위로 쪼그라든 뒤에야 스크롤이 생김
 */
const wrapGuideTables = (html: string): string => {
  if (typeof DOMParser === 'undefined') return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const tables = Array.from(doc.body.querySelectorAll('table')).filter(
    (table) => !table.parentElement?.closest('table'),
  );
  if (!tables.length) return html;
  tables.forEach((table) => {
    const attrWidth = (table.getAttribute('width') || '').trim();
    if (!table.style.width && /^\d+(\.\d+)?(px|%)?$/.test(attrWidth))
      table.style.width = /\d$/.test(attrWidth) ? `${attrWidth}px` : attrWidth;
    if (isFluidWidth(table.style.width.trim()))
      table.classList.add(TABLE_FLUID_CLASS);
    const wrapper = doc.createElement('div');
    wrapper.className = TABLE_SCROLL_CLASS;
    table.replaceWith(wrapper);
    wrapper.appendChild(table);
  });
  // 본문 앞의 <style> 등은 파서가 head 로 옮김 — 같이 돌려줘야 빠지지 않음
  return doc.head.innerHTML + doc.body.innerHTML;
};

export default wrapGuideTables;
